import { render, staticRenderFns } from "./FamiliesGraph.vue?vue&type=template&id=532cb504&"
import script from "./FamiliesGraph.vue?vue&type=script&lang=js&"
export * from "./FamiliesGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports